export default __webpack_public_path__ + "static/media/photo9.42be209a.jpg";